import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $error,
  $gateway,
  $gatewayExchanger,
  gatewayMounted,
  getGateway,
} from './model'

export const useGateway = () => {
  const gateway = useStore($gateway)
  const gatewayExchanger = useStore($gatewayExchanger)
  const loading = useStore(getGateway.pending)
  let error = useStore($error)

  React.useEffect(() => {
    gatewayMounted()
  }, [])

  return { gateway, gatewayExchanger, loading, error }
}
